import { render, staticRenderFns } from "./FreeProductItem.vue?vue&type=template&id=74f3da97&scoped=true&"
import script from "./FreeProductItem.vue?vue&type=script&lang=js&"
export * from "./FreeProductItem.vue?vue&type=script&lang=js&"
import style0 from "./FreeProductItem.vue?vue&type=style&index=0&id=74f3da97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f3da97",
  null
  
)

export default component.exports